import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import rootReducer from '../reducers';
import * as LogRocket from 'logrocket';

import rootSaga from '../sagas';

const sagaMiddleware = createSagaMiddleware({
  onError: (error) => {
    console.error(error);
  },
});

const configureStore = (preloadedState) => {
  const store = createStore(
    rootReducer,
    preloadedState,
    compose(
      applyMiddleware(thunk),
      applyMiddleware(sagaMiddleware),
      applyMiddleware(LogRocket.reduxMiddleware()),
    ),
  );
  sagaMiddleware.run(rootSaga);
  return store;
};

export default configureStore;
